
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { DocumentProps } from "@/hooks/admin/identity-docs/useSubmittedDocuments";
import { DocumentActionsSimplified } from "./table/DocumentActionsSimplified";
import { StatusBadge } from "./table/StatusBadge";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2 } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";

interface UserDocumentsListProps {
  documents: DocumentProps[];
  onDocumentUpdated: () => void;
}

export function UserDocumentsList({ documents, onDocumentUpdated }: UserDocumentsListProps) {
  const isMobile = useIsMobile();
  
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  if (isMobile) {
    return (
      <div className="space-y-4">
        {documents.map((doc) => (
          <div key={doc.id} className="border rounded-md p-4 space-y-3">
            <div className="flex justify-between items-center">
              <div>
                <div className="font-medium flex items-center gap-2">
                  {doc.id_document_types.document_name}
                  {doc.primary_document && (
                    <Badge variant="secondary" className="ml-1 flex items-center gap-1">
                      <CheckCircle2 className="h-3 w-3" />
                      <span>Primary</span>
                    </Badge>
                  )}
                </div>
                <div className="text-xs text-muted-foreground">
                  Submitted: {formatDate(doc.submitted_at)}
                </div>
              </div>
              <StatusBadge status={doc.verification_status} />
            </div>
            
            <div className="pt-2 flex justify-end">
              <DocumentActionsSimplified document={doc} onDocumentUpdated={onDocumentUpdated} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Document Type</TableHead>
          <TableHead>Submitted</TableHead>
          <TableHead>Status</TableHead>
          <TableHead className="text-right">Actions</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {documents.map((doc) => (
          <TableRow key={doc.id}>
            <TableCell className="font-medium flex items-center gap-2">
              {doc.id_document_types.document_name}
              {doc.primary_document && (
                <Badge variant="secondary" className="ml-1 flex items-center gap-1">
                  <CheckCircle2 className="h-3 w-3" />
                  <span>Primary</span>
                </Badge>
              )}
            </TableCell>
            <TableCell>{formatDate(doc.submitted_at)}</TableCell>
            <TableCell>
              <StatusBadge status={doc.verification_status} />
            </TableCell>
            <TableCell>
              <DocumentActionsSimplified document={doc} onDocumentUpdated={onDocumentUpdated} />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
